import React from "react";
import { MetricCards, MetricCardsProps } from "./MetricCards";
import { StatCardsHeader, StatCardsHeaderProps } from "./StatCardsHeader";
import { ChevronUp } from "@puzzle/icons";
import { DASHBOARD_METRIC_CARDS_COLLAPSED } from "constants/localStorageKeys";
import { useLocalStorage } from "react-use";
import { Collapse, Button, Box } from "@puzzle/ve";
import { isPosthogFeatureFlagEnabled, FeatureFlag } from "lib/analytics/featureFlags";
import { space } from "@puzzle/theme";
import { EmptyStateOverlay } from "components/common/EmptyStateOverlay/EmptyStateOverlay";
import { useFinancialInstitutions } from "components/integrations/shared/FinancialInstitutionsProvider";
import { StatCardsNoConnectionsEmptyState } from "components/dashboard/Transactions/components/EmptyStates/TransactionConnectionsEmptyStateBase";
import { baseContainerStyle } from "./financialInsights.css";

type FinancialInsightsProps = MetricCardsProps & StatCardsHeaderProps;

export const FinancialInsights = ({
  metricCards,
  metricCardStatus,
  onChangeStatus,
  onChangeOrder,
  charts,
  chartsLoading,
}: FinancialInsightsProps) => {
  const { accounts, accountsLoading } = useFinancialInstitutions();
  const [collapsed, setCollapsed] = useLocalStorage(DASHBOARD_METRIC_CARDS_COLLAPSED, false);
  const isDashboardCustomizeButtonEnabled = isPosthogFeatureFlagEnabled(
    FeatureFlag.DashboardCustomizeButton
  );

  const showEmptyStateOverlay =
    (!accounts || accounts.length === 0) &&
    !accountsLoading &&
    isPosthogFeatureFlagEnabled(FeatureFlag.TransactionsNoFIEmptyStates);

  return (
    <>
      <Collapse open={!collapsed} visibleOverflow animate>
        <EmptyStateOverlay
          showOverlay={showEmptyStateOverlay}
          overlayComponent={<StatCardsNoConnectionsEmptyState />}
        >
          <Box
            className={baseContainerStyle}
            css={{
              marginBottom: showEmptyStateOverlay ? space["4"] : 0,
            }}
          >
            {isDashboardCustomizeButtonEnabled && (
              <StatCardsHeader
                metricCards={metricCards}
                metricCardStatus={metricCardStatus}
                onChangeStatus={onChangeStatus}
                onChangeOrder={onChangeOrder}
              />
            )}
            <MetricCards
              metricCards={metricCards}
              metricCardStatus={metricCardStatus}
              charts={charts}
              chartsLoading={chartsLoading}
            />
          </Box>
        </EmptyStateOverlay>
      </Collapse>
      <Button
        variant="secondary"
        onClick={() => setCollapsed(!collapsed)}
        css={{
          alignSelf: "center",
          display: showEmptyStateOverlay ? "none" : "unset",
        }}
        suffixElement={<ChevronUp rotate={collapsed ? 180 : 0} />}
      >
        {collapsed ? "Expand insights" : "Collapse insights"}
      </Button>
    </>
  );
};
